export default __webpack_public_path__ + "static/media/whiteArrowIcon.9fb5ca9a.svg";